import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import DataTable from 'react-data-table-component';
import { useSelector } from "react-redux";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import { resetVw_MembersToInit, setVw_MembersMessage } from "redux/actions";
import { resetMembersToInit, setMembersMessage } from "redux/actions";
import { deleteMembers } from "services/vw_membersService";

import { Row, Button, Card, Col, Form, InputGroup } from "react-bootstrap";
import { Constant } from "template/Constant";
import ConfirmationModal from "template/ConfirmationModal";

import designationLevel from "../../data/designationLevel.json";
import designation from "../../data/designation.json";
import vibhag from "../../data/vibhag.json";
import jillas from "../../data/jilla.json";
import nagars from "../../data/nagar.json";
import upamandal from "../../data/upamandal.json";
import basti from "../../data/basti.json";
import baseurl from 'baseurl';
import { useFormik } from "formik";
import { updateMembers } from "services/membersService";
import designation_upamandal from "../../data/designation_upamandal.json";
import designation_basti from "../../data/designation_basti.json";

const generalStyles = {
    marginTop: '3%'
}

const dropdownstyle = {
    borderColor: 'black',
    backgroundImage: "none",
}

const responsivefordropdowns = {
    height: "53px",
    width: "100%",
    display: "inline-block",
}
type Props = {
    hideShowForm: (action) => void;
    handleRowEdit: (row) => void;
    getData: (page, pageSize, searchKey) => void;
};
export const Vw_MembersTable: React.FC<Props> = ({ hideShowForm, handleRowEdit, getData }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [search, setSearch] = useState('');
    const [showDelete, setShowDelete] = useState(false);

    const [isEditable, setIsEditable] = useState(undefined);
    const [rowData, setRowData] = useState(undefined);
    const [selectedvalue, setSelectedvalue] = useState(undefined);
    const [newRow, setNewRow] = useState(undefined);
    const rData = useSelector((state: RootState) => state.vw_members);
    const handleSearch = () => {
        if (search.length > 0) {
            getData(Constant.defaultPageNumber, Constant.defaultPageSize, search);
        }
    }
    const handlePerRowsChange = async (newPerPage, page) => {
        await getData(page, newPerPage, '');
    }
    const handlePageChange = (page) => {
        getData(page, rData.pageSize, '');
    };

    const handleRowDeleteClick = (row) => {
        console.log("deleterow", row.is_active);

        const changeStatus = {
            member_id: row.member_id,
            status: row.is_active == 1 ? 0 : 1
        }
        setRowData(changeStatus);
        setShowDelete(true);
    }
    // useEffect(() => {
    //     if (rData && rData.list && rData.list.length === 0) {
    //         dispatch(resetVw_MembersToInit());
    //         getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
    //     }
    // }, [rData.list.length])

    useEffect(() => {
        getData(Constant.defaultPageNumber, Constant.defaultPageSize, "");
    }, []);

    const handleReset = () => {
        setSearch('');
        dispatch(resetVw_MembersToInit());
        getData(Constant.defaultPageNumber, rData.pageSize, '');
    }
    const handleServerDelete = async () => {
        if (rowData) {
            const response = await deleteMembers(rowData);
            if (response) {
                console.log("deleteresponse", response);
                // dispatch(resetMembersToInit());
                dispatch(setMembersMessage("Status Changed Successfully"));
                let newvalues = {};

                if (formik.values.vibhag_id !== 0 && designationlevelId == "1") {
                    newvalues = {
                        stayi: '3',
                        vibhag: formik.values.vibhag_id
                    };
                }
                if (formik.values.zill_id !== 0 && designationlevelId == "1") {
                    newvalues = {
                        stayi: '4',
                        zilla: formik.values.zill_id
                    };
                }
                if (formik.values.nagar_khanda_id !== 0 && designationlevelId == "1") {
                    newvalues = {
                        stayi: '5',
                        nagar_khanda: formik.values.nagar_khanda_id
                    };
                }
                if (formik.values.upamandal_basti_id !== 0 && designationlevelId == "1") {
                    newvalues = {
                        stayi: '6',
                        upamandal_basti: formik.values.upamandal_basti_id
                    };
                }



                if (formik.values.vibhag_id !== 0 && designationlevelId == "2") {
                    newvalues = {
                        stayi: '2',
                        vibhag: formik.values.vibhag_id
                    };
                }
                if (formik.values.zill_id !== 0 && designationlevelId == "2") {
                    newvalues = {
                        stayi: '4',
                        zilla: formik.values.zill_id
                    };
                }
                if (formik.values.nagar_khanda_id !== 0 && designationlevelId == "2") {
                    newvalues = {
                        stayi: '5',
                        nagar_khanda: formik.values.nagar_khanda_id
                    };
                }
                if (formik.values.upamandal_basti_id !== 0 && designationlevelId == "2") {
                    newvalues = {
                        stayi: '6',
                        upamandal_basti: formik.values.upamandal_basti_id
                    };
                }



                if (formik.values.zill_id !== 0 && designationlevelId == "3") {
                    newvalues = {
                        stayi: '4',
                        zilla: formik.values.zill_id
                    };
                }
                if (formik.values.nagar_khanda_id !== 0 && designationlevelId == "3") {
                    newvalues = {
                        stayi: '5',
                        nagar_khanda: formik.values.nagar_khanda_id
                    };
                }
                if (formik.values.upamandal_basti_id !== 0 && designationlevelId == "3") {
                    newvalues = {
                        stayi: '6',
                        upamandal_basti: formik.values.upamandal_basti_id
                    };
                }

                if (formik.values.nagar_khanda_id !== 0 && designationlevelId == "4") {
                    newvalues = {
                        stayi: '5',
                        nagar_khanda: formik.values.nagar_khanda_id
                    };
                }
                if (formik.values.upamandal_basti_id !== 0 && designationlevelId == '4') {
                    newvalues = {
                        stayi: '6',
                        upamandal_basti: formik.values.upamandal_basti_id
                    };
                }

                if (formik.values.upamandal_basti_id !== 0 && designationlevelId == '5') {
                    newvalues = {
                        stayi: '6',
                        upamandal_basti: formik.values.upamandal_basti_id
                    };
                }

                console.log('newvalues', newvalues);

                getData(Constant.defaultPageNumber, rData.pageSize, newvalues);
                setShowDelete(false);
            } else {
                dispatch(setMembersMessage("Some error occured!"));
            }
        }
    }

    const handleRowSelection = (row) => {
        console.log(row); // Row Selection Functionality can be written here
    }
    const handleAddButtonClick = () => {
        dispatch(setVw_MembersMessage(''));
        hideShowForm('add');
    }

    var jsonArray1 = upamandal;
    var jsonArray2 = basti;
    jsonArray1 = jsonArray1.concat(jsonArray2);

    const designationlevelId = localStorage.getItem("desig_level_id");
    const vibahgId = localStorage.getItem("vibhag_id");
    const zillId = localStorage.getItem("zill_id");
    const nagarkhandId = localStorage.getItem("nagar_khanda_id");
    const upamandabastiId = localStorage.getItem("upamandal_basti_id");

    const filteredVibhags = vibhag.filter((vibhag) => vibhag.vibhag_id === 8 || vibhag.vibhag_id === 9);

    const filterjillasonlogin = jillas.filter((jilla) => jilla.vibhag_id == parseInt(vibahgId));

    const filterkhandasonlogin = nagars.filter((nagar) => nagar.jilla_id == parseInt(zillId));

    const upamandalbastinagarkhand = upamandal.filter((upamandal_basti) => upamandal_basti.nagar_khanda_id == parseInt(nagarkhandId))

    const bastinagarkhand = basti.filter((upamandal_basti) => upamandal_basti.nagar_khanda_id == parseInt(nagarkhandId))

    console.log("bastinagarkhand1122", bastinagarkhand);

    const iValue = {
        desig_level_id: localStorage.getItem('desig_level_id'),
        vibhag_id: 0,
        zill_id: 0,
        nagar_khanda_id: 0,
        upamandal_basti_id: 0
    };



    const formik = useFormik({
        initialValues: iValue,
        onSubmit: values => {

            let newvalues = {};

            if (values.vibhag_id !== 0 && designationlevelId == "1") {
                newvalues = {
                    stayi: '3',
                    vibhag: values.vibhag_id
                };
            }
            if (values.zill_id !== 0 && designationlevelId == "1") {
                newvalues = {
                    stayi: '4',
                    zilla: values.zill_id
                };
            }
            if (values.nagar_khanda_id !== 0 && designationlevelId == "1") {
                newvalues = {
                    stayi: '5',
                    nagar_khanda: values.nagar_khanda_id
                };
            }
            if (values.upamandal_basti_id !== 0 && designationlevelId == "1") {
                newvalues = {
                    stayi: '6',
                    upamandal_basti: values.upamandal_basti_id
                };
            }



            if (values.vibhag_id !== 0 && designationlevelId == "2") {
                newvalues = {
                    stayi: '2',
                    vibhag: values.vibhag_id
                };
            }
            if (values.zill_id !== 0 && designationlevelId == "2") {
                newvalues = {
                    stayi: '4',
                    zilla: values.zill_id
                };
            }
            if (values.nagar_khanda_id !== 0 && designationlevelId == "2") {
                newvalues = {
                    stayi: '5',
                    nagar_khanda: values.nagar_khanda_id
                };
            }
            if (values.upamandal_basti_id !== 0 && designationlevelId == "2") {
                newvalues = {
                    stayi: '6',
                    upamandal_basti: values.upamandal_basti_id
                };
            }



            if (values.zill_id !== 0 && designationlevelId == "3") {
                newvalues = {
                    stayi: '4',
                    zilla: values.zill_id
                };
            }
            if (values.nagar_khanda_id !== 0 && designationlevelId == "3") {
                newvalues = {
                    stayi: '5',
                    nagar_khanda: values.nagar_khanda_id
                };
            }
            if (values.upamandal_basti_id !== 0 && designationlevelId == "3") {
                newvalues = {
                    stayi: '6',
                    upamandal_basti: values.upamandal_basti_id
                };
            }

            if (values.nagar_khanda_id !== 0 && designationlevelId == "4") {
                newvalues = {
                    stayi: '5',
                    nagar_khanda: values.nagar_khanda_id
                };
            }
            if (values.upamandal_basti_id !== 0 && designationlevelId == '4') {
                newvalues = {
                    stayi: '6',
                    upamandal_basti: values.upamandal_basti_id
                };
            }

            if (values.upamandal_basti_id !== 0 && designationlevelId == '5') {
                newvalues = {
                    stayi: '6',
                    upamandal_basti: values.upamandal_basti_id
                };
            }

            console.log('newvalues', newvalues);

            getData(Constant.defaultPageNumber, rData.pageSize, newvalues);
        }
    });

    const handleEdit = (row) => {
        setIsEditable(row)
    }


    const handleSubmit = async () => {
        const response = await updateMembers(isEditable);
        setIsEditable(undefined);
        getData(Constant.defaultPageNumber, Constant.defaultPageSize, search);

    }
    const dynamicSelect = (row, column, rowName) => {
        return <Form.Control
            as="select"
            value={isEditable ? isEditable[rowName] : row[rowName]}
            onChange={e => {
                var a_row = JSON.parse(JSON.stringify(isEditable));
                a_row[rowName] = e.target.value;
                setIsEditable(a_row);
            }}
            className="form-control"
        >
            {
                column === "Stayi" &&
                designationLevel.map((level) => {
                    return <option key={level.desig_level_id} value={level.desig_level_id}>{level.desig_level_name}</option>
                })
            }
            {
                column == "Vibhag" &&
                vibhag.map((level) => {
                    return <option key={level.vibhag_id} value={level.vibhag_id}>{level.vibhag_name}</option>
                })
            }
            {
                column == "Zilla" &&
                jillas.map((jilla) => {
                    if (jilla.vibhag_id == isEditable.vibhag_id) {
                        return jilla.jillas.map(level => {
                            return <option key={level.jilla_id} value={level.jilla_id}>{level.jilla_name}</option>
                        })
                    }

                })
            }
            {
                column == "Nagar/Khanda" &&
                nagars.map((nagar) => {
                    if (nagar.jilla_id == isEditable.zill_id) {
                        return nagar.nagar.map(level => {
                            return <option key={level.nagar_khanda_id} value={level.nagar_khanda_id}>{level.nagar_khanda_name}</option>
                        })
                    }

                })
            }
            {
                column == "Upamandal" && isEditable.desig_level_id == '6' &&
                upamandal.map((upamandal_basti) => {
                    if (upamandal_basti.nagar_khanda_id == isEditable.nagar_khanda_id) {
                        return upamandal_basti.upamandal_bastis.map(level => {
                            return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}{" - Upamandal"}</option>
                        })

                    }
                    else { <option value=''>No Data Found</option> }

                })
            }
            {
                column == "Basti" && isEditable.desig_level_id == '7' &&
                basti.map((upamandal_basti) => {
                    if (upamandal_basti.nagar_khanda_id == isEditable.nagar_khanda_id) {
                        return upamandal_basti.upamandal_bastis.map(level => {
                            return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}{" - Basti"}</option>
                        })
                    }
                    else { <option value=''>No Data Found</option> }

                })

            }
            {
                column === "Badhyata" && isEditable.desig_level_id != '6' && isEditable.desig_level_id != '7' &&
                designation.map((level) => {
                    return <option key={level.designation_id} value={level.designation_id}>{level.designation_name}</option>
                })
            }
            {
                column === "Badhyata" && isEditable.desig_level_id == '6' &&
                designation_upamandal.map((level) => {
                    return <option key={level.designation_id} value={level.designation_id}>{level.designation_name}</option>
                })
            }
            {
                column === "Badhyata" && isEditable.desig_level_id == '7' &&
                designation_basti.map((level) => {
                    return <option key={level.designation_id} value={level.designation_id}>{level.designation_name}</option>
                })

            }
            {
                column === "Prabhari" && isEditable.desig_level_id == '3' &&
                jillas.map((jilla) => {
                    if (jilla.vibhag_id == isEditable.vibhag_id) {
                        return jilla.jillas.map(level => {
                            return <option key={level.jilla_id} value={level.jilla_id}>{level.jilla_name}</option>
                        })
                    }

                })
            }
            {
                column === "Prabhari" && isEditable.desig_level_id == '4' &&
                nagars.map((nagar) => {
                    if (nagar.jilla_id == isEditable.zill_id) {
                        return nagar.nagar.map(level => {
                            return <option key={level.nagar_khanda_id} value={level.nagar_khanda_id}>{level.nagar_khanda_name}</option>
                        })
                    }

                })
            }
            {
                column === "Prabhari" && isEditable.desig_level_id == '5' &&
                [upamandal.map((upamandal_basti) => {
                    if (upamandal_basti.nagar_khanda_id == isEditable.nagar_khanda_id) {
                        return upamandal_basti.upamandal_bastis.map(level => {
                            return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}{" - Upamandal"}</option>
                        })
                    }

                }),
                basti.map((upamandal_basti) => {
                    if (upamandal_basti.nagar_khanda_id == isEditable.nagar_khanda_id) {
                        return upamandal_basti.upamandal_bastis.map(level => {
                            return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}{" - Basti"}</option>
                        })
                    }
                    else { <option value=''>No Data Found</option> }

                })
                ]
            }

        </Form.Control>
    }


    const columns = [
        { name: 'Name', selector: row => row.member_name, sortable: true },
        { name: 'Mobile', selector: row => row.mobile_number, sortable: true },
        { name: 'Stayi', selector: row => isEditable && row.member_id == isEditable.member_id ? dynamicSelect(row, "Stayi", "desig_level_id") : row.desig_level_name, sortable: true },
        { name: 'Vibhag', selector: row => isEditable && row.member_id == isEditable.member_id ? dynamicSelect(row, "Vibhag", "vibhag_id") : row.vibhag_name, sortable: true },
        { name: 'Zilla', selector: row => isEditable && row.member_id == isEditable.member_id ? dynamicSelect(row, "Zilla", "zill_id") : row.zilla_name, sortable: true },
        { name: 'Nagar/Khanda', selector: row => isEditable && row.member_id == isEditable.member_id ? dynamicSelect(row, "Nagar/Khanda", "nagar_khanda_id") : row.nagar_khanda_name, sortable: true },
        { name: 'Upamandal', selector: row => isEditable && row.member_id == isEditable.member_id ? dynamicSelect(row, "Upamandal", "upamandal_basti_id") : row.upamandal_name, sortable: true },
        { name: 'Basti', selector: row => isEditable && row.member_id == isEditable.member_id ? dynamicSelect(row, "Basti", "upamandal_basti_id") : row.basti_name, sortable: true },
        { name: 'Badhyata', selector: row => isEditable && row.member_id == isEditable.member_id ? dynamicSelect(row, "Badhyata", "designation_id") : row.designation_name, sortable: true },
        { name: 'Prabhari', selector: row => isEditable && row.member_id == isEditable.member_id ? dynamicSelect(row, "Prabhari", "prabhari_id") : row.Prabhari_Name, sortable: true },
        // { name: 'created_on', selector: row => new Date(row.created_on).toLocaleString(undefined, { timeZone: 'Asia/Kolkata' }), sortable: true },
        {
            name: 'Edit',
            button: true,
            cell: (row) => isEditable && isEditable.member_id == row.member_id ? <Button variant="link" className="btn-sm" onClick={handleSubmit}><i className="fa fa-check" aria-hidden="true"></i></Button> :
                <Button variant="link" className="btn-sm" onClick={() => handleRowEdit
                    (row)}>Edit</Button>,
        },
        {
            name: 'Status',
            button: true,
            cell: (row) => <Button variant="link" className="btn-sm" onClick={() => handleRowDeleteClick(row)}><span style={{ color: row.is_active === 1 ? "green" : "red" }}>
                {row.is_active === 1 ? "Active" : "Inactive"}
            </span></Button>,
        },

    ];
    return (
        <form onSubmit={formik.handleSubmit}>
            <Card className="shadow mb-4">
                <Card.Header className="py-3">
                    <h6 className="m-0 font-weight-bold text-primary"> Karyakartha Soochi ({rData.totalCount})
                        <Button variant="light" className="btn-circle btn-sm ml-2" onClick={handleReset}><i className="fa fa-refresh"></i></Button>
                    </h6>

                </Card.Header>

                <Card.Body>
                    <Row className="justify-content-between">
                        <Col md={12} xs={8} xl={2}>
                        </Col>
                        <Col md={12} xs={8} xl={2}>
                            <InputGroup style={responsivefordropdowns}>
                                {(
                                    designationlevelId == '1' ||
                                    designationlevelId == '2'
                                ) &&
                                    <Form.Group>
                                        <Form.Control
                                            as="select"
                                            name="vibhag_id"
                                            value={formik.values.vibhag_id}
                                            onChange={e => {
                                                formik.values.zill_id = 0
                                                formik.values.nagar_khanda_id = 0
                                                formik.values.upamandal_basti_id = 0
                                                formik.handleChange(e)
                                            }}
                                            onBlur={formik.handleBlur}
                                            style={dropdownstyle}
                                            className="form-control"
                                            isInvalid={!!formik.touched.vibhag_id && !!formik.errors.vibhag_id}
                                            isValid={!!formik.touched.vibhag_id && !formik.errors.vibhag_id}>
                                            <option value="">-- Select Vibhag --</option>

                                            {
                                                designationlevelId == "2" && filteredVibhags && filteredVibhags.length > 0 ?

                                                    filteredVibhags.map((level) => {
                                                        return <option key={level.vibhag_id} value={level.vibhag_id}>{level.vibhag_name}</option>
                                                    })
                                                    :

                                                    vibhag.map((level) => {
                                                        return <option key={level.vibhag_id} value={level.vibhag_id}>{level.vibhag_name}</option>
                                                    })
                                            }

                                        </Form.Control>
                                        {
                                            formik.errors.vibhag_id && (
                                                <Form.Control.Feedback type="invalid">
                                                    <>{formik.errors.vibhag_id}</>
                                                </Form.Control.Feedback>
                                            )}
                                    </Form.Group>}
                            </InputGroup>
                        </Col>
                        <Col md={12} xs={8} xl={2}>
                            <InputGroup style={responsivefordropdowns}>
                                {(
                                    designationlevelId == "1" ||
                                    designationlevelId == "2" ||
                                    designationlevelId == "3"
                                ) &&
                                    <Form.Group>
                                        <Form.Control
                                            as="select"
                                            name="zill_id"
                                            value={formik.values.zill_id}
                                            onChange={e => {
                                                formik.values.nagar_khanda_id = 0
                                                formik.values.upamandal_basti_id = 0
                                                formik.handleChange(e)
                                            }}
                                            onBlur={formik.handleBlur}
                                            style={dropdownstyle}

                                            className="form-control"
                                            isInvalid={!!formik.touched.zill_id && !!formik.errors.zill_id}
                                            isValid={!!formik.touched.zill_id && !formik.errors.zill_id}>
                                            <option value="">-- Select Jilla --</option>
                                            {
                                                filterjillasonlogin && filterjillasonlogin.length > 0 ?
                                                    filterjillasonlogin.map((jilla) => {
                                                        return jilla.jillas.map(level => {
                                                            return <option key={level.jilla_id} value={level.jilla_id}>{level.jilla_name}</option>
                                                        })
                                                    })
                                                    :
                                                    jillas.map((jilla) => {
                                                        if (jilla.vibhag_id == formik.values.vibhag_id) {
                                                            return jilla.jillas.map(level => {
                                                                return <option key={level.jilla_id} value={level.jilla_id}>{level.jilla_name}</option>
                                                            })
                                                        }
                                                    })
                                            }

                                        </Form.Control>
                                        {
                                            formik.errors.zill_id && (
                                                <Form.Control.Feedback type="invalid">
                                                    <>{formik.errors.zill_id}</>
                                                </Form.Control.Feedback>
                                            )}
                                    </Form.Group>}
                            </InputGroup>
                        </Col>
                        <Col md={12} xs={8} xl={2}>
                            <InputGroup style={responsivefordropdowns}>
                                {(
                                    designationlevelId == "1" ||
                                    designationlevelId == "2" ||
                                    designationlevelId == "3" ||
                                    designationlevelId == "4"
                                ) &&
                                    <Form.Group>
                                        <Form.Control
                                            as="select"
                                            name="nagar_khanda_id"
                                            value={formik.values.nagar_khanda_id}
                                            onChange={e => {
                                                formik.values.upamandal_basti_id = 0
                                                formik.handleChange(e)
                                            }}
                                            onBlur={formik.handleBlur}
                                            style={dropdownstyle}

                                            className="form-control"
                                            isInvalid={!!formik.touched.nagar_khanda_id && !!formik.errors.nagar_khanda_id}
                                            isValid={!!formik.touched.nagar_khanda_id && !formik.errors.nagar_khanda_id}
                                        >
                                            <option value="">-- Select Khanda/Nagar --</option>
                                            {
                                                filterkhandasonlogin && filterkhandasonlogin.length > 0 ?
                                                    filterkhandasonlogin.map((nagar) => {
                                                        return nagar.nagar.map(level => {
                                                            return <option key={level.nagar_khanda_id} value={level.nagar_khanda_id}>{level.nagar_khanda_name}</option>
                                                        })
                                                    })
                                                    :
                                                    nagars.map(
                                                        (nagar) => {
                                                            if (nagar.jilla_id == formik.values.zill_id) {
                                                                return nagar.nagar.map(level => {
                                                                    return <option key={level.nagar_khanda_id} value={level.nagar_khanda_id}>{level.nagar_khanda_name}</option>
                                                                })
                                                            }

                                                        }
                                                    )
                                            }

                                        </Form.Control>
                                        {
                                            formik.errors.nagar_khanda_id && (
                                                <Form.Control.Feedback type="invalid">
                                                    <>{formik.errors.nagar_khanda_id}</>
                                                </Form.Control.Feedback>
                                            )}
                                    </Form.Group>}
                            </InputGroup>
                        </Col>
                        <Col md={12} xs={8} xl={2}>
                            <InputGroup style={responsivefordropdowns}>
                                {(
                                    designationlevelId == "1" ||
                                    designationlevelId == "2" ||
                                    designationlevelId == "3" ||
                                    designationlevelId == "4" ||
                                    designationlevelId == "5"

                                ) &&
                                    <Form.Group>
                                        <Form.Control
                                            as="select"
                                            name="upamandal_basti_id"
                                            value={formik.values.upamandal_basti_id}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            style={dropdownstyle}

                                            className="form-control"
                                            isInvalid={!!formik.touched.upamandal_basti_id && !!formik.errors.upamandal_basti_id}
                                            isValid={!!formik.touched.upamandal_basti_id && !formik.errors.nagar_khanda_id}
                                        >
                                            <option value="">-- Select Upamandal-Basti --</option>
                                            {
                                                upamandalbastinagarkhand && upamandalbastinagarkhand.length > 0 ?
                                                    upamandalbastinagarkhand.map((upamandal_basti) => {
                                                        return upamandal_basti.upamandal_bastis.map(level => {
                                                            return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}{" - Upamandal"}</option>
                                                        })
                                                    })
                                                    :
                                                    bastinagarkhand && bastinagarkhand.length > 0 ?
                                                        (bastinagarkhand.map((upamandal_basti) => {
                                                            return upamandal_basti.upamandal_bastis.map(level => {
                                                                return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}{" - Upamandal"}</option>
                                                            })
                                                        }))

                                                        :

                                                        (
                                                            jsonArray1.map((upamandal_basti) => {
                                                                if (upamandal_basti.nagar_khanda_id == formik.values.nagar_khanda_id) {
                                                                    return upamandal_basti.upamandal_bastis.map(level => {
                                                                        return <option key={level.upamandal_basti_id} value={level.upamandal_basti_id}>{level.upamandal_basti_name}{" - Upamandal"}</option>
                                                                    })

                                                                }
                                                            })
                                                        )
                                            }



                                        </Form.Control>
                                        {
                                            formik.errors.upamandal_basti_id && (
                                                <Form.Control.Feedback type="invalid">
                                                    <>{formik.errors.upamandal_basti_id}</>
                                                </Form.Control.Feedback>
                                            )}
                                    </Form.Group>}
                            </InputGroup>
                        </Col>

                        <Col className="ml-auto" xl={0} md={12} xs={12}>
                            {designationlevelId != "6" && "7" && (
                                <div style={{ display: "flex" }}>
                                    <button type="submit" style={{ marginLeft: "auto" }} >
                                        Search
                                    </button>
                                </div>
                            )}
                        </Col>

                    </Row>
                    <div className="table-responsive">
                        <DataTable
                            // selectableRows={isSelectable}
                            onSelectedRowsChange={handleRowSelection}
                            paginationPerPage={Constant.defaultPageNumber}
                            paginationRowsPerPageOptions={Constant.paginationRowsPerPageOptions}
                            columns={columns}
                            data={rData.list}
                            onChangeRowsPerPage={handlePerRowsChange}
                            paginationTotalRows={rData.totalCount}
                            className="table table-bordered"
                            // pagination
                            // paginationServer
                            onChangePage={handlePageChange}></DataTable>
                    </div>
                </Card.Body>
                <ConfirmationModal buttonNegative="Cancel" buttonPositive="Change" title="Confirm Status Change" show={showDelete} body={"Are you sure want to change?"} onNegative={() => setShowDelete(false)} onPositive={handleServerDelete} />

            </Card>
        </form>
    );
}

